import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useMediaQuery } from 'react-responsive';
import styled, { createGlobalStyle, css } from 'styled-components';
import { Footer } from "../components/Footer";
import Header from "../components/Header";
import { Layout } from "../components/Layout";
import { ProductLink } from "../components/ProductLink";
import { ScrollIndicator } from "../components/ScrollIndicator";
import { ShareLinks } from "../components/ShareLinks";
import { VideoModal } from '../components/VideoModal';
import PlayIcon from '../images/play-circle-light.inline.svg';
import { COLOURS } from "../styles/Colours";
import { BigQuote, Block, MediumQuote, Subtitle, Title } from "../styles/Components";
import { STYLES } from "../styles/Styles";
import {
  HomeParagraph1,
  HomeParagraph2,
  HomeParagraph3,
  HomeParagraph4,
  HomeParagraph5,
  HomeParagraph6,
  HomeParagraph7,
  HomeParagraph8,
  HomeParagraph9,
  HomeQuote1,
  HomeQuote2,
  HERO_SUBTITLE_TEXT
} from './../components/Copy';

const IndexPage = (props: any) => {

  const [isVideoModalVisible, setIsVideoModalVisible] = useState<boolean>(false);
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  useEffect(() => {
  }, []);

  const {
    heroImage,
    Pocock_Tassie_266,
    Pocock_Tassie_247,
    Pocock_Tassie_205,
    Pocock_Tassie_94,
    Pocock_Tassie_136,
    Pocock_Tassie_201,
    Pocock_Tassie_318,
    Pocock_Tassie_311,
    Pocock_Tassie_284,
    Pocock_Tassie_397,
    Pocock_Tassie_406,
    Pocock_Tassie_304
  } = props.data;

  return (
    <Layout inverseColor footer={false} header={false}>
      <Helmet>
        <meta name="robots" content="index,follow" />
        <title>David Pocock's Passion for Photography & Conservation Collide</title>
        <meta name="description" content="Join Australia Wallabies' forward David Pocock on his journey through the Tarkine region in Tasmania where he let two of his passions collide; wildlife photography and conservation" />
        <meta name="site-section" content="Explore" />
        <meta name="page-template" content="Story Page" />
        <meta name="page-category" content="Get Inspired" />
        <meta name="og:title" property="og:title" content="David Pocock's Passion for Photography & Conservation Collide" />
        <meta name="og:description" property="og:description" content="Join Australia Wallabies' forward David Pocock on his journey through the Tarkine region in Tasmania where he let two of his passions collide; wildlife photography and conservation" />
      </Helmet>
      <HomeStyles />
      <VideoModal
        visible={isVideoModalVisible}
        setIsVisible={setIsVideoModalVisible}
      />
      <ScrollIndicator />
      <HomePageContainer id='scrollingContent'>
        <ParallaxContainer>
          <Header inverseHeader />

          <Hero>
            <StyledImg fluid={heroImage.childImageSharp.fluid} imgStyle={{objectPosition: 'right 0%'}}/>
            <Titles>
              <Title>An Unlikely Union</Title>
              <Subtitle>{HERO_SUBTITLE_TEXT}</Subtitle>
            </Titles>
            <PlayVideo onClick={() => setIsVideoModalVisible(true)}>
              <PlayText>Watch the video</PlayText><PlayIcon height='50px' />
            </PlayVideo>
          </Hero>
          <Content>
            <Block>
              <HomeQuote1 />
              <ShareLinks style={{padding: '3rem 0'}}/>
              <HomeParagraph1 />
            </Block>
            <ImageContainer style={{margin: '0 auto', maxWidth: STYLES.desktopSize, width: '100%'}}>
                <GatsbyImg fluid={Pocock_Tassie_266.childImageSharp.fluid} alt='' mobileHeight={300} desktopHeight={700}/>
              <ImageCaption>Taken with <ProductLink product='EOS 5D Mark IV'/>. <ProductLink product='EF 24-105mm f/4L IS USM' />. ISO 1000, f/5.0, 1/200s</ImageCaption>
            </ImageContainer>
            <Block>
              <HomeParagraph2 />
            </Block>
            <ImageContainer>
                <GatsbyImg fluid={Pocock_Tassie_247.childImageSharp.fluid} alt='' mobileHeight={300} desktopHeight={700}/>
              <ImageCaption>Taken with <ProductLink product='EOS-1D X Mark II' />. <ProductLink product='EF 200-400mm f/4L IS USM Extender 1.4X' />. ISO 3200, f/7.1, 1/1250s</ImageCaption>
            </ImageContainer>
            <Block>
              <HomeParagraph3 />
            </Block>
            <Images>
              <ImageContainer>
                  <GatsbyImg fluid={Pocock_Tassie_205.childImageSharp.fluid} mobileHeight={400} desktopHeight={600}/>
                <ImageCaption>Taken with <ProductLink product='EOS R' />. <ProductLink product='RF 24-105mm f/4L IS USM' />. ISO 2000, f/4.0, 1/160s</ImageCaption>
              </ImageContainer>
              <ImageContainer>
                  <GatsbyImg fluid={Pocock_Tassie_94.childImageSharp.fluid} mobileHeight={400} desktopHeight={600}/>
                <ImageCaption>Taken with <ProductLink product='EOS 5D Mark IV' />. <ProductLink product='EF 50mm f/1.2L USM' />. ISO 640, f/3.5, 1/80s</ImageCaption>
              </ImageContainer>
            </Images>
            <Block>
              <HomeParagraph4 />
            </Block>
            <ImageContainer>
                <GatsbyImg fluid={Pocock_Tassie_136.childImageSharp.fluid} alt='' mobileHeight={300} desktopHeight={700}/>
              <ImageCaption>Taken with <ProductLink product='EOS 5D Mark IV' />. <ProductLink product='EF 24-105mm f/4L IS USM' />. ISO 800, f/4.0, 1/125s</ImageCaption>
            </ImageContainer>
            <Block>
              <HomeParagraph5 />
            </Block>
            <Block>
              <HomeQuote2 />
            </Block>
            <Images>
              <ImageContainer>
                  <GatsbyImg fluid={Pocock_Tassie_201.childImageSharp.fluid} mobileHeight={400} desktopHeight={600} />
                <ImageCaption>Taken with <ProductLink product='EOS-1D X Mark II' />. <ProductLink product='EF 200-400mm f/4L IS USM Extender 1.4X' />. ISO 800, f/5.6, 1/500s</ImageCaption>
              </ImageContainer>
              <ImageContainer>
                  <GatsbyImg fluid={Pocock_Tassie_318.childImageSharp.fluid} mobileHeight={400} desktopHeight={600}/>
                <ImageCaption>Taken with <ProductLink product='EOS-1D X Mark II' />. <ProductLink product='EF 16-35mm f/2.8L II USM' />. ISO 1250, f/3.2, 1/40s</ImageCaption>
              </ImageContainer>
            </Images>
            <Block>
              <HomeParagraph6 />
            </Block>
            <ImageContainer style={{margin: '0 auto', maxWidth: STYLES.desktopSize, width: '100%'}}>
                <GatsbyImg fluid={Pocock_Tassie_311.childImageSharp.fluid} alt='' mobileHeight={300} desktopHeight={700}/>
              <ImageCaption>Taken with <ProductLink product='EOS 5D Mark IV' />. <ProductLink product='EF 50mm f/1.2L USM' />. ISO 6400, f/3.5, 1/120s</ImageCaption>
            </ImageContainer>
            <Block>
              <HomeParagraph7 />
            </Block>
            <ImageContainer style={{ width: '100%' }}>
                <GatsbyImg fluid={Pocock_Tassie_284.childImageSharp.fluid} alt='' mobileHeight={300} desktopHeight={600}/>
              <ImageCaption>Taken with <ProductLink product='EOS-1D X Mark II' />. <ProductLink product='EF 200-400mm f/4L IS USM Extender 1.4X' />. ISO 12800, f/7.1, 1/1600s</ImageCaption>
            </ImageContainer>
            <Block>
              <HomeParagraph8 />
            </Block>
            <Images>
              <ImageContainer>
                  <GatsbyImg fluid={Pocock_Tassie_397.childImageSharp.fluid} mobileHeight={400} desktopHeight={600} />
                <ImageCaption>Taken with <ProductLink product='EOS 5D Mark IV' />. <ProductLink product='EF 24-105mm f/4L IS USM' />. ISO 1000, f/2.8, 1/640s</ImageCaption>
              </ImageContainer>
              <ImageContainer>
                  <GatsbyImg fluid={Pocock_Tassie_406.childImageSharp.fluid} mobileHeight={400} desktopHeight={600}/>
                <ImageCaption>Taken with <ProductLink product='EOS 5D Mark IV' />. <ProductLink product='EF 24-105mm f/4L IS USM' />. ISO 1000, f/2.8, 1/1000s</ImageCaption>
              </ImageContainer>
            </Images>
            <Block>
              <HomeParagraph9 />
            </Block>
            <ImageContainer style={{margin: '0 auto', maxWidth: STYLES.desktopSize, width: '100%'}}>
                <GatsbyImg fluid={Pocock_Tassie_304.childImageSharp.fluid} alt='' mobileHeight={300} desktopHeight={700}/>
              <ImageCaption>Taken with <ProductLink product='EOS 5D Mark IV' />. <ProductLink product='EF 50mm f/1.2L USM' />. ISO 1000, f/5.0, 1/500s</ImageCaption>
            </ImageContainer>
            <Footer />
          </Content>
        </ParallaxContainer>
      </HomePageContainer>
    </Layout>
  )
};

const StyledImg = styled(Img)`
  height: 100vh;
  width: 100vw;
  opacity: 0.4;
`;

const HomeStyles = createGlobalStyle`
  main {
  }
  body {
    height: 100%;
  }
  #layout {
    height: 100% !important;
  }
`;

const ParallaxContainer = styled.div`
  perspective: 1px;
  perspective-origin: 0 0;
  transform-style: preserve-3d;
  width: 100%;
  height: 100%;
  min-height: min-content;
  display: flex;
  position: relative;
  flex-direction: column;
`;

const HomePageContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transform-style: preserve-3d;
`;

const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${COLOURS.charcoal};
  color: ${COLOURS.white};
  background-position: center top;
  background-size: cover;
  position: relative;

  position: sticky;
  top: 0px;

  transform-origin: 0 0;
  transform: translateZ(-2px) scale(3);
  transform-style: preserve-3d;

  z-index: -1;
  flex-shrink: 0;
`;

const Content = styled.div`
  background-color: ${COLOURS.background};
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: min-content;
`;

const Titles = styled.div`
  margin-top:  ${STYLES.headerSize};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: auto;
  text-align: center;
  width: 100%;
  padding: 0 2rem;
  position: absolute;
  top: 30%;
  >*:not(:first-child) {
    margin-top: 0.5rem;
  }
`;

const PlayVideo = styled.div`
  margin: auto 0;
  display: flex;
  align-items: center;
  height: 40px;
  position: absolute;
  top: 60%;
  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const PlayText = styled.span`
  font-size: 22px;
  margin-right: 1rem;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: center;

  @media(min-width: ${STYLES.desktopSize}) {
    padding: 2rem 0;
  }
`;

interface ImageWrapperProps {
  mobileHeight?: number;
  desktopHeight?: number;
}

const ImageWrapper = styled.div<ImageWrapperProps>`
  display: flex;

  @media(max-width: ${STYLES.desktopSize}) {
    height: ${props => `${props.mobileHeight}px`};
  }
  @media(min-width: ${STYLES.desktopSize}) {
    height: ${props => `${props.desktopHeight}px`};
  }

`;

const Image = styled.img`
  width: 100%;
`;

const GatsbyImg = styled(Img)<any>`
  width: 100%;
  @media(max-width: ${STYLES.desktopSize}) {
    height: ${props => `${props.mobileHeight}px`};
  }
  @media(min-width: ${STYLES.desktopSize}) {
    height: ${props => `${props.desktopHeight}px`};
  }
`;


const ImageCaption = styled.span`
  max-width: ${STYLES.maxWidth};
  width: 100%;
  padding: 0.5rem 0;
  @media(max-width: ${STYLES.desktopSize}) {
    padding: 0.5rem 1.5rem;
  }
`;

const Images = styled.div`
  display: flex;
  @media(min-width: ${STYLES.desktopSize}) {
    padding: 0 4rem;
    >* {
      margin: 0 1rem;
      flex: 1;
    }
  }
  @media(max-width: ${STYLES.desktopSize}) {
    flex-direction: column;
  }
`;

export default IndexPage;

export const pageQuery = graphql`
  query {
    heroImage: file(relativePath: { eq: "photos/5. Pocock_Tassie-98.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 3000) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_266: file(relativePath: { eq: "highres/Pocock_Tassie-266.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_247: file(relativePath: { eq: "photos/31. Pocock_Tassie-247.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1680) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_205: file(relativePath: { eq: "photos/11. Pocock_Tassie-205.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_94: file(relativePath: { eq: "photos/8. Pocock_Tassie-94.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_136: file(relativePath: { eq: "photos/4. Pocock_Tassie-136.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1680) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_201: file(relativePath: { eq: "photos/17. Pocock_Tassie-201.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_318: file(relativePath: { eq: "photos/12. Pocock_Tassie-318.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_311: file(relativePath: { eq: "highres/Pocock_Tassie-311.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_284: file(relativePath: { eq: "photos/20. Pocock_Tassie-284.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_397: file(relativePath: { eq: "photos/24. Pocock_Tassie-397.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_406: file(relativePath: { eq: "photos/26. Pocock_Tassie-406.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    Pocock_Tassie_304: file(relativePath: { eq: "photos/1. Pocock_Tassie-304.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    },
  }
`;
